import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';

const SELECTOR_WRAPPER = '.p-school-resources-library';
const SELECTOR_FORM = '.js-resources-library-filter';

const CLICK_EVENT = 'click';

class SchoolResourceLibrary {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.filterForm = SelectorEngine.findOne(SELECTOR_FORM, this._wrapper);
		this.submitForm = SelectorEngine.find('.js-resources-library-filter-submit', this._wrapper);
		for (const submitButton of this.submitForm) {
			EventHandler.on(submitButton, CLICK_EVENT, () => {
				this.filterForm.submit();
			});
		}
	}
}

const globalSchoolResourceLibrary = new SchoolResourceLibrary();
export default globalSchoolResourceLibrary;
